// the comments next to the icon names indicate that the name was changed when it was transferred from PL
// multiple names in the comment indicate duplicates in PL
const availableIcons = [
    "ampersand",
    "application-bending", // services-icon-bending-tools
    "application-cutting", // hotspot-fertigung-schneiden
    "application-flame-cutting", // application-icon-flame-cutting
    "application-laser-cutting", // application-icon-laser-cutting
    "application-plasma-cutting", // application-icon-plasma-cutting
    "archive",
    "arrow-big-left",
    "arrow-big-right",
    "arrow-down",
    "arrow-right",
    "arrow-left",
    "arrow-nav-left",
    "arrow-nav-left-double",
    "arrow-nav-right",
    "arrow-nav-right-double",
    "arrow-small-down",
    "arrow-small-left",
    "arrow-small-right",
    "arrow-small-up",
    "automation", // hotspot-automatisierung smart-factory-icon-automation
    "avatar", // contact-general startpage-icon-contact-general person_pocket
    "avatar-calculation", // hotspot-angebotserstellung
    "avatar-contact", //icon-newsroom-press-contact
    "avatar-contacts", // mytrumpf-icon-contacts
    "avatar-connectivity",
    "avatar-circle-small", // profil
    "avatar-culture", // responsibility-culture-social responsibility-icon-culture-social
    "avatar-customer", // person
    "avatar-customer-admin", // customer_admin_easyorder
    "avatar-customer-multiple", // customer-report-icon-number-of-employees
    "avatar-dialog", // responsibility-icon-society
    "avatar-directions", // bank-icon-financial-independence
    "avatar-multiple", // responsibility-icon-employees
    "avatar-plus", // services-icon-mytrumpf
    "avatar-technical-service", // contact-general-technical-service
    "avatar-wrench", // services-icon-technical-services person_pocket-wrench
    "box-open",
    "backpack", // career-icon-school-students
    "bag", // career-icon-professionals
    "books", // career-icon-students
    "calendar", // Calender_Icon calendar startpage-icon-events-calendar
    "call-predictive",
    "camera",
    "camera-denied", // camera_denied
    "cart",
    "cart-bending-tools", // services-icon-e-shop-bending-tools
    "cart-genuine-parts", // services-icon-e-shop-genuine-parts
    "cart-punching-tools", // services-icon-e-shop-punching-tools

    /** @deprecated "case-in-progress" should be replaced with "wrench-circle-arrow" */
    "case-in-progress",

    "certificate", // services-icon-AM-certification
    "checklist-eye",
    "checkmark", // Checkmark_whitepaper checkmark
    "checkmark-magnifier",

    "checkmark-rounded-thin",
    "checkmark-thin",
    "circle-empty",
    "circle-filled",
    "circle-filled-cross", // circle-filled-gray_cross
    "circle-arrow-right", // arrow-right_rounded_circle
    "circle-two-arrows",
    "circle-eye", // stufen_eye-icon
    "circle-hand", // stufen_hand-icon
    "circle-plus", // plus-rounded_circle
    "circle-declined",
    "circle-checked",
    "circle-questionmark",
    "circles", // smart-factory-icon-why-TruConnect
    "clipboard-checkmark", // icon_already-ordered
    "clipboard-list-checkmark",
    "clock", // clock-time
    "clock-arrow",
    "clock-arrow-pen", // career-icon-dual-students-short-duration-of-study
    "clock-timer", // timer_icon

    // TODO
    "close",
    "close-bold",
    "close-thin",
    "cog", // gear
    "cog-circles", // bank-icon-holistic-consulting
    "cog-chart", // bank-icon-flexible-financing-concepts
    "cog-hands", // bank-icon-solutions-for-you
    "cog-multiple", // three-cogs
    "combs", // smart-factory-icon-products
    "copy",
    "crane",
    "cube",
    "decision-tree",
    "decision-tree-symbols",
    "delete", // icon_delete trash-can
    "delete-circle-red", // trashcan_circle_bg-red
    "dialog", // smart-factory-icon-well-advised
    "dialog-secure", // secure-communication
    "document-checkmark", // services-icon-service-agreements
    "document-list-edit",
    "documents", // startpage-icon-orders
    "documents-screen",
    "download",
    "download-arrow", // startpage-icon-downloadcenter
    "draft",
    "edit", // icon_edit
    "error-analytics",
    "eye-striked",
    "error", // uic:flag-error
    "factory", // customer-report-icon-industry factory smart-factory-company
    "faq",
    "fav", // Fav_Border_Icon flag_outline
    "fav-filled", // Fav_Fill_Icon flag_filled
    "file-bnc",
    "file-dxf",
    "file-generic",
    "file-mp4",
    "file-pdf",
    "file-scdoc",
    "file-stp",
    "filter-horizontal", // smart-factory-icon-horizontal
    "filter-vertical", // smart-factory-icon-vertical
    "financial-bank", // services-icon-financing
    "financial-calculator", // services-icon-financial-calculator
    "financial-grow", // smart-factory-icon-your-benefits
    "financial-grow-circle", // services-icon-process-optimization
    "financial-moneybag", // moneybag-budget
    "financial-quoting", // receive_quotation_icon general-icon-request-offer consulting
    "financial-sales", // customer-report-icon-sales
    "free-of-interferences",
    "genuine-parts", // services-icon-genuine-parts
    "germany-pin", // services-icon-aussendienstsuche
    "globe", // service_globe
    "globe-fine", // responsibility-icon-environment
    "globe-small", // meta_globe
    "globe-coordinates", // globe
    "globe-pin", // startpage-icon-locations
    "globe-circle-arrows", // career-icon-working-abroad
    "graduates", // career-icon-graduates
    "graduates-professionals", // career-icon-graduates-professionals
    "hashtag",
    "hand-plus", // career-icon-additional-benefits
    "horizon", // career-icon-dual-students-best-perspectives
    "hourglass-circle-arrow", // clock-waiting hourglass_circle-arrow
    "info-circle", // stufen_info-icon
    "info-rounded", // info-border info-circle-filled mytrumpf-icon-info
    "info",
    "intralogistics", // hotspot-intralogistik
    "lightbulb", // responsibility-icon-education
    "lightbulb-approved", // lightbulb_approved
    "lightbulb-denied", // lightbulb_denied
    "like", // thumbs-up
    "like-filled", // thumbs-up-v2
    "list",
    "machine", // startpage-icon-machines
    "machine-checked", // machine_checkmark-border-right
    "machine-circle-arrows", // services-icon-pre-owned-machines
    "machine-connected", // smart-factory-just-begin
    "machine-desktop", // machine_connected-desktop
    "machine-factory-connected", // smart-factory-completely-networked
    "machine-fav",
    "machine-gauge",
    "machine-magnifier", // productfinder productfinder_with_border
    "machine-multiple-connected", // smart-factory-adjust-gradually
    "machine-plus", // services-icon-product-enhancements
    "machine-progress-magnifier", // services-icon-condition-analytics
    "machine-screen-control",
    "magnifier-chart", // services-icon-visual-assistances
    "mail", // contact-form contact mail_v2 mail
    "mail-arrow-right", // mail_arrow-right
    "mail-arrow-right-green", // mail_arrow-right-green
    "mail-approved", // mail_approved transaction-success
    "mail-denied", // mail_denied transaction-failed
    "mail-open", // mail-document startpage-icon-newsletter
    "mandatory", // uic:flag-mandatory
    "manual-power-tools", // services-icon-operating-manuals-pt
    "material-magnifier",
    "material-scrap",
    "message-unread",
    "menu",
    "minus",
    "monitoring", // services-icon-monitoring-and-analysis
    "order-status-package-checkmark",
    "packages", // services-icon-value-packages
    "package-error", // product-error
    "pause", // global-pause
    "pencil-line", // pencil-draw-line icon-pencil-draw-line
    "performance-cockpit", // easy_order_cockpit services-icon-easy-order-cockpit mytrumpf-icon-performance-cockpit
    "phone",
    "phone-circle-arrows", // phone_circle-two-arrows
    "play", // global-play
    "play-filled",
    "play-rounded",
    "plus",

    /** @deprecated use circle-plus instead! */
    "plus-rounded",

    "plus-small",
    "powder", // services-icon-powder
    "press", // startpage-icon-press
    "print-search", // print-icon
    "process-circle-arrows",
    "programming", // hotspot-fertigung-programmierung
    "progress-magnifier", // services-icon-critical-findings
    "reload",
    "reset",

    // NAVIGATION SPECIFIC
    "nav-contact",
    "nav-globe",
    "nav-home",
    "nav-notification",
    "nav-profile",
    "nav-search",
    "nav-settings",
    "nav-shopping-cart",
    "nav-applications",
    "nav-industry",
    "nav-success-story",

    // Notification specific
    "no-notification",
    "notification-information",
    "notification-warning",
    "notification-error",

    "question-mark-approved", // icon-questionmark_approved questionmark_approved
    "quotation-mark", // quotation_down

    "sample-kit", // icon-newsroom-media-kits
    "search", // lupe_multi lupe
    "search-small", // search
    "service-agreement", // smart-factory-icon-services
    "shipping", // hotspot-versand
    "shop-order", // mytrumpf-icon-easyorder
    "shop-devices", // easy_order_cockpit services-icon-easy-order-cockpit
    "showroom", // services-icon-showroom
    "signpost", // career-icon-professional-development
    "smartphone-apps", // general-icon-apps services-icon-app
    "snowflake",
    "social-share", // share_icon
    "social-facebook", // social_facebook
    "social-google-plus", // social_googleplus
    "social-instagram",
    "screw-magnifying-glass",
    "social-kununu",
    "social-line", // social_line
    "social-linkedin", // social_linkedin
    "social-twitter", // social_twitter
    "social-wechat", // icon-social_wechat
    "social-xing", //social_xing
    "social-youtube", // social_youtube
    "software", // services-icon-software
    "software-avatar-registration", // event-registration
    "software-error-404",
    "software-error-500",
    "software-images", //icon-newsroom-mediapool
    "software-licensing", // services-icon-software-licensing
    "software-speed", // high-speed
    "software-warning", // program-window_warning-sign
    "sort", // Sort_Icon
    "square", // bullet-point bullet
    "square-in", // ical login
    "square-out", // logout
    "star", // favorites_active favorites_inactive star-quality
    "star-filled", // favorites star
    "theory-and-practice", // career-icon-dual-students-theory-and-practice
    "ticket",
    "tiles", // menu-dotted
    "tiles-outline", // overview
    "tiles-big",
    "tiles-big-magnifier", // career-icon-dual-students-get-to-know-many-departments
    "tiles-screen-magnifier",
    "tools", // services-icon-repair
    "tools-punching-bending", // services-icon-tools
    "tools-punching", // services-icon-punching-tools
    "tools-punching-scanner", // services-icon-punching-tool-scanner
    "training", // mytrumpf-icon-trainings
    "training-avatar", // services-icon-training
    "truck",
    "truck-checkmark-center", // truck_checkmark-center
    "upload",

    "warning", // hazardous_warning
    "warning-screen-magnifier",
    "warning-triangle", // warn-sign-double-border warn-sign uic:flag-warning
    "warning-triangle-simple",
    "warranty-5-years", // services-icon-5-year-warranty
    "watchlist",
    "wrench",
    "wrench-checkmark",
    "wrench-circle-arrow", // wrench_circle-arrow
    "wrench-circle-arrows",
    "wrench-circle-arrow-mail-green", // wrench_circle-arrow_mail-green
    "wrench-clock-arrow",
    "wrench-cog",
    "wrench-plus",
    "wrench-simple", // wrench
    "zoom-in",
    "zoom-out",
].filter((icon) => {
    const isValid = /^[a-z]+(-[a-z]*[0-9]*)*$/.test(icon); // don't change this line - it ensures all icons use the correct naming scheme.
    // shows a warning only in Storybook
    if ("__STORYBOOK_ADDONS" in window && !isValid) {
        console.warn(`The name of the icon "${icon}" is invalid.`);
    }
    return isValid;
});

export default availableIcons;
